import styles from './ProgressLine.module.less'

interface Props {
  className?: string
  videoSize: { width: string, height: string, left: string, top: string }
  x: number
  dimensionLen: number
  disableTransition?: boolean
}


function ProgressLine(props: Props) {
  const {
    height, top
  } = props.videoSize


  return <div className={styles.progressLine} style={{
    height, top,
    transform: `translateX(${props.x}px)`,
    transition: props.disableTransition ? 'none' : undefined,
    display: props.dimensionLen > 0 ? 'block' : 'none'
  }}></div>
}

export default ProgressLine
